<template>
  <v-list-tile
    :class="{active, 'elevation-5': active, 'grey--text': opaque }"
    @click="$emit('click', item)"
    v-ripple
  >
    <!-- Show the string of the item -->
    <v-list-tile-content>
      <div>
        <span>{{ item[itemText] }}</span>
      </div>
    </v-list-tile-content>
    <!-- Stats to show when we are listing the mapped values and not the raw values -->
    <template v-if="itemText === 'mapped'">
      <!-- Show how many values are mapped to this one -->
      <v-item-tile-stat
        v-if="item.values"
        color="deep-purple lighten-2"
        :description="`Hay ${item.values.length} valores mapeados a '${item[itemText]}'`"
        icon="send"
        :opaque="opaque"
        :stat="item.values.length"
      />
      <!-- Show the distance to the current active value if "distance" is present in the item -->
      <v-item-tile-stat
        v-if="item.distance"
        color="pink lighten-2"
        :description="`Hay ${item.distance} caracteres de diferencia entre '${item[itemText]}' y '${activeMappedItemValue}'`"
        icon="call_split"
        :opaque="opaque"
        :stat="item.distance"
      />
    </template>
    <!-- The frequency of the value in the data -->
    <v-item-tile-stat
      color="orange lighten-1"
      :description="`Hay ${item.frequency} '${item[itemText]}' en la data`"
      icon="timeline"
      :opaque="opaque"
      :stat="item.frequency"
    />
    <!-- A button to remove this value from the mapped items in the database and in the app -->
    <v-item-tile-delete-btn v-if="removable" :value="item[itemText]" />
  </v-list-tile>
</template>

<script>
import { mapState } from "vuex";
import VItemTileDeleteBtn from "./ItemTileDeleteBtn";
import VItemTileStat from "./ItemTileStat";

/**
 * This component renders a tile for the ValuesList component that shows the raw value or the
 * mapped values with their stats.
 */
export default {
  components: {
    VItemTileDeleteBtn,
    VItemTileStat
  },
  props: {
    /* Highlight the component if its active, apply elevation and a border-left solid line */
    active: {
      type: Boolean
    },
    /* The item with the `frequency`, `value` and `mapped` properties */
    item: {
      type: Object,
      required: true
    },
    /* The key of the property of the item to show as text in the tile */
    itemText: {
      type: String,
      default: "value"
    },
    /* Make the item opaque, apply grey text */
    opaque: {
      type: Boolean
    },
    /* Make the item removable, show a clear button. Useful for the items showing a specific value inside
     * a mapped group to remove the item from the group. */
    removable: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("valueMapping", ["activeMappedItem", "showingMappedValues"]),
    activeMappedItemValue() {
      return this.activeMappedItem[
        this.showingMappedValues ? "mapped" : "value"
      ];
    }
  }
};
</script>

<style scoped>
.active {
  border-radius: 3px 0 0 3px;
  border-left: 3px solid #29b6f6;
}
</style>